// extracted by mini-css-extract-plugin
export default {"a_footer":"Footer_a_footer__1GYFZ"};